var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 13.3334V14.3334C6.0979 14.3334 6.35225 14.228 6.53979 14.0405L5.83268 13.3334ZM3.16602 13.3334H2.16602C2.16602 13.8857 2.61373 14.3334 3.16602 14.3334V13.3334ZM3.16602 10.6667L2.45891 9.95962C2.27137 10.1472 2.16602 10.4015 2.16602 10.6667H3.16602ZM10.6946 3.13813L11.4017 3.84524L11.4017 3.84524L10.6946 3.13813ZM11.6374 3.13813L10.9303 3.84524L10.9303 3.84524L11.6374 3.13813ZM13.3613 4.86199L14.0684 4.15488L14.0684 4.15488L13.3613 4.86199ZM13.3613 5.8048L12.6542 5.09769L13.3613 5.8048ZM5.83268 12.3334H3.16602V14.3334H5.83268V12.3334ZM4.16602 13.3334V10.6667H2.16602V13.3334H4.16602ZM3.87312 11.3738L11.4017 3.84524L9.9875 2.43103L2.45891 9.95962L3.87312 11.3738ZM10.9303 3.84524L12.6542 5.5691L14.0684 4.15488L12.3445 2.43103L10.9303 3.84524ZM12.6542 5.09769L5.12558 12.6263L6.53979 14.0405L14.0684 6.51191L12.6542 5.09769ZM12.6542 5.5691C12.524 5.43892 12.524 5.22787 12.6542 5.09769L14.0684 6.51191C14.7193 5.86103 14.7193 4.80576 14.0684 4.15488L12.6542 5.5691ZM11.4017 3.84524C11.2715 3.97541 11.0605 3.97541 10.9303 3.84524L12.3445 2.43103C11.6937 1.78015 10.6384 1.78015 9.9875 2.43103L11.4017 3.84524Z",
    fill: "#689858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.33325L11.1667 7.99992",
    stroke: "#689858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPencil);
export default __webpack_public_path__ + "static/media/green-pencil.be493d6edb1c06b22d805e0fd5ecaea7.svg";
export { ForwardRef as ReactComponent };